import { createAction } from 'redux-actions'

import {
  LOGIN,
  LOGIN_ERROR,
  LOGIN_FINALLY,
  LOGIN_START,
  LOGIN_SET_AUTH,
  LOGIN_SET_PROFILE,
} from './Views/Auth/auth.actions'
import {
  INIT_SAGAS,
  INIT_SAGAS_ERROR,
  INIT_SAGAS_FINALLY,
  INIT_SAGAS_START,
} from './Controllers/Init/init.actions'
import { SET_COMPANY } from './Controllers/Company/company.actions'
import {
  POINTS_SET_POINTS,
  POINTS_SET_SELECTED_POINT_START,
  POINTS_SET_SELECTED_POINT_SUCCEEDED,
  POINTS_SET_SELECTED_POINT_FINALLY,
  POINTS_CREATE_CACHE,
  POINTS_CREATE_CACHE_START,
  POINTS_CREATE_CACHE_SUCCEEDED,
} from './Controllers/Points/points.actions'
import { SET_CLASIFICATIONS } from './Controllers/Clasifications/clasifications.action'
import { SET_TAGS } from './Controllers/Tags/tags.actions'
import {
  SET_FORMS_AND_DEPENDENCIES,
  FORM_SELECT_FORM,
  FORM_SELECT_POINT,
  FORM_SELECT_POINT_START,
  FORM_SELECT_POINT_ERROR,
  FORM_SELECT_POINT_SUCCEEDED,
  FORM_SET_STAGE,
  FORM_ADD_QUESTIONS_VALUE,
  FORM_SET_STAGE_START,
  FORM_SET_STAGE_SUCCEEDED,
  FORM_SET_STAGE_ERROR,
  FORM_SET_STAGE_FINALLY,
  FINALIZE_FORM,
  FINALIZE_FORM_START,
  FINALIZE_FORM_ERROR,
  FINALIZE_FORM_SUCCEEDED,
  FINALIZE_FORM_FINALLY,
  FORM_SET_QUESTIONS_VALUE,
  FORM_DETAIL,
  FORM_DETAIL_START,
  FORM_DETAIL_ERROR,
  FORM_DETAIL_FINALLY,
  FORM_DETAIL_SUCCEEDED,
  FORM_SET_START_FORM,
  FORM_SET_PENDING_FORM,
  FORM_SET_PENDING_SUCCEEDED,
  FORM_SET_STEP,
  FORM_CLEAN_FORM,
} from './Views/Forms/forms.actions'
import {
  GET_EXTRAS,
  PUT_EXTRAS,
} from './Controllers/Extras/extras.actions'
import {
  GET_ADDONS,
  SET_ADDONS,
} from './Controllers/Addons/addons.actions'
import {
  SET_WIDGETS,
} from './Controllers/Widgets/widgets.action'

const LOGOUT = createAction('LOGOUT')

export {
  // AUTH
  LOGOUT,
  LOGIN,
  LOGIN_ERROR,
  LOGIN_FINALLY,
  LOGIN_START,
  LOGIN_SET_AUTH,
  LOGIN_SET_PROFILE,
  // INITIAL
  INIT_SAGAS,
  INIT_SAGAS_ERROR,
  INIT_SAGAS_FINALLY,
  INIT_SAGAS_START,
  // CONTROLLERS
  SET_COMPANY,
  // POINTS
  POINTS_SET_POINTS,
  POINTS_SET_SELECTED_POINT_START,
  POINTS_SET_SELECTED_POINT_SUCCEEDED,
  POINTS_SET_SELECTED_POINT_FINALLY,
  POINTS_CREATE_CACHE,
  POINTS_CREATE_CACHE_START,
  POINTS_CREATE_CACHE_SUCCEEDED,
  // FORMS
  FORM_CLEAN_FORM,
  SET_FORMS_AND_DEPENDENCIES,
  FORM_SELECT_FORM,
  FORM_SELECT_POINT,
  FORM_SELECT_POINT_START,
  FORM_SELECT_POINT_ERROR,
  FORM_SELECT_POINT_SUCCEEDED,
  FORM_ADD_QUESTIONS_VALUE,
  FORM_SET_QUESTIONS_VALUE,
  FORM_SET_STAGE,
  FORM_SET_STAGE_START,
  FORM_SET_STAGE_SUCCEEDED,
  FORM_SET_STAGE_ERROR,
  FORM_SET_STAGE_FINALLY,
  FINALIZE_FORM,
  FINALIZE_FORM_START,
  FINALIZE_FORM_ERROR,
  FINALIZE_FORM_SUCCEEDED,
  FINALIZE_FORM_FINALLY,
  FORM_DETAIL,
  FORM_DETAIL_START,
  FORM_DETAIL_ERROR,
  FORM_DETAIL_FINALLY,
  FORM_DETAIL_SUCCEEDED,
  FORM_SET_START_FORM,
  FORM_SET_PENDING_FORM,
  FORM_SET_PENDING_SUCCEEDED,
  FORM_SET_STEP,
  // CLASIFICATIONS
  SET_CLASIFICATIONS,
  // TAGS
  SET_TAGS,
  // EXTRAS
  GET_EXTRAS,
  PUT_EXTRAS,
  // ADDONS
  GET_ADDONS,
  SET_ADDONS,
  // WIDGETS
  SET_WIDGETS,
}
